<template>
  <div class="home">
    <div class="content-wrapper" v-if="getTranslationsAPI">
      <div class="message-h1" v-html="getTranslationsAPI.cms_title"></div>
      <div class="message-h2" v-html="getTranslationsAPI.cms_subtitle"></div>
      <div class="message-h3" v-html="getTranslationsAPI.cms_end_date"></div>
      <VideoList  />
    </div>
    <Footer />
  </div>
</template>

<script>
import VideoList from '@/components/VideoList.vue'
import Footer from '@/components/Footer.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import router from '@/router/index.js'
import LocalStorageService from '@/services/LocalStorageService'

export default {
  name: 'Home',
  components: {
    VideoList,
    Footer
  },
  computed: {
    ...mapGetters(['getTranslationsAPI'])
  },
  methods: {
    ...mapMutations(['setIsAdult', 'setVideoId']),
    ...mapActions(['getSession', 'getParticipations'])
  },
  created () {
    const params = {
      alias_url: this.$route.params.alias_url,
      preview: this.$route.params.preview === 'preview' ? this.$route.params.preview : ''
    }
    this.getSession()
    if (LocalStorageService.ifTrue('isAdult')) {
      this.setIsAdult(true)
      this.setVideoId(null)
      this.getParticipations(params)
    } else {
      const partialPath = params.preview === 'preview' ? `/${params.alias_url}/preview` : `/${params.alias_url}`
      router.push({ path: `${partialPath}` })
    }
  }
}
</script>
<style scoped>
.home {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  min-height: 100vh;
}
.content-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100%;
  margin-top: 4rem;
  padding: 1rem;
}
.title {
  font-weight: 700;
  font-size: 1.875rem;
  line-height: 2.25rem;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: var(--primary);
  width: 700px;
}
@media (min-width: 768px) {
  .title {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
}
@media (max-width: 767.9px) {
  .title {
    width: 370px;
  }
}
.message-h1 {
  font-size: 1.5rem;
  line-height: 2rem;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
}
@media (min-width: 768px) {
  .message-h1 {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
}
.message-h2 {
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
}
@media (min-width: 768px) {
  .message-h2 {
    font-size: 1.5rem;
    line-height: 2rem;
  }
}
.message-h3 {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  text-align: center;
}
@media (min-width: 768px) {
  .message-h3 {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
</style>
